import { IDeleteRequestsStore } from './types';

const initStore: IDeleteRequestsStore = {
  current: null,
  list: [],
  pagination: {
    total: 0,
    pageNumber: 1,
    pageSize: 25,
  },
};

export default initStore;
